// import { MenuAim } from 'es6-menu-aim';
import { MenuAim } from '../lib/es6-menu-aim.js';
import Affix from '../lib/affix.js';

export default {
	init: function() {

		document.querySelectorAll('#nav-trigger, #nav-close').forEach((ele) => {
			ele.addEventListener('click', e => {
				e.preventDefault();
				document.querySelector('#menu').classList.toggle('open');
			});
		});

		let menuEle, config;

		menuEle = document.getElementById('menu-parent');

		if (!menuEle) {
			console.debug('[nav.js] menu element not present');
			return;
		}

		config = {
			activate: function(row) {
				let dropdown = row.querySelector('.dropdown');

				if(row.classList) {
					row.classList.add('dropdown--open');
				} else {
					row.className += ' dropdown--open';
				}

				if(dropdown !== null) {
					dropdown.style.left = (row.offsetWidth - 10) + 'px';
				}

			},
			deactivate: function(row) {
				if(row.classList) {
					row.classList.remove('dropdown--open');
				} else {
					row.className = row.className.replace(new RegExp('(^|\\b)' + 'dropdown--open'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
				}
			},
			rowSelector: '.menu-item-0',
			openClassName: 'dropdown--open',
			activationDelay: 1000,
			tolerance: 1000,
			submenuSelector: '.dropdown'
		};

		this.affix = new Affix('#nav', document.querySelectorAll('main')[0]);
		this.menuAim = new MenuAim(menuEle, config);
	},
}

